/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import TableList from '../TableList';
import TableSummary from '../TableSummary';

import OrderTable from './styled';

export const CheckoutOrderTable = ({
    order,
    nextLink,
    nextLinkTk,
    buttonLoading,
    buttonOnClick,
    changeItemQuantity,
    removeItem,
    readOnly,
    displaySummaryNote,
    children,
    renderButton,
}) => (
    <OrderTable>
        <TableList
            orderProducts={order.items || []}
            orderCurrencySymbol={order.currencySymbol}
            changeItemQuantity={changeItemQuantity}
            removeItem={removeItem}
            readOnly={readOnly}
        />
        <TableSummary
            orderCurrencySymbol={order.currencySymbol}
            orderSubtotal={order.item_total}
            orderShipping={order.shipment_total}
            orderVoucherDiscount={order.voucher && order.voucher.discount}
            orderTotal={order.total}
            orderDiscount={order.discount_total}
            orderTax={order.us_sales_tax}
            nextLink={nextLink}
            nextLinkTk={nextLinkTk}
            buttonLoading={buttonLoading}
            buttonOnClick={buttonOnClick}
            displaySummaryNote={displaySummaryNote}
            renderButton={renderButton}
            mobile={false}
        >
            {children}
        </TableSummary>
    </OrderTable>
);

CheckoutOrderTable.propTypes = {
    order: PropTypes.shape({}).isRequired,
    nextLink: PropTypes.node,
    nextLinkTk: PropTypes.string,
    buttonLoading: PropTypes.bool,
    buttonOnClick: PropTypes.func,
    changeItemQuantity: PropTypes.func,
    removeItem: PropTypes.func,
    readOnly: PropTypes.node,
    displaySummaryNote: PropTypes.bool,
    children: PropTypes.node,
    renderButton: PropTypes.func,
};

CheckoutOrderTable.defaultProps = {
    nextLink: undefined,
    nextLinkTk: '',
    buttonLoading: undefined,
    buttonOnClick: () => {},
    changeItemQuantity: () => {},
    removeItem: () => {},
    readOnly: undefined,
    displaySummaryNote: undefined,
    children: undefined,
    renderButton: undefined,
};

export default CheckoutOrderTable;
